import React, {Component, Fragment} from 'react';
import $ from 'jquery';
import {_addNotificationError} from "../../../../server/util";

class YearMealForm extends Component{
    allGrades=()=> {
        var select_all = document.getElementById("select_all");
        this.props.onChangeGradeSelection('select_all',select_all.checked);
        //$('input[name="grades"]').prop('checked',this.checked);
        var checkboxes = document.getElementsByName("grades");
        for (let i = 0; i < checkboxes.length; i++) {
            if(!checkboxes[i].disabled)
            checkboxes[i].checked = select_all.checked;
        }
    }
    checkAllGrades = (event) => {        
        this.props.onChangeGradeSelection(event.target.value,event.target.checked);

        var checkboxes = document.getElementsByName("grades");
        let j = 0;
        for (let i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].checked) {
                //alert(j)
                j++
            }

        }
        var select_all = document.getElementById("select_all");

        if (j === checkboxes.length) {
            select_all.checked = true;

        } else {
            select_all.checked = false;

        }

    }
    render(){
        return(<Fragment>
            <div className="row">
                <div className="col-md-8 col-sm-12 col-xs-12 text-center createmenu-panel">
                    <div className="panel panel-primary">
                        <div className="panel-heading text-center">
                            <h3 className="panel-title">{'Create Lunch Menu'}</h3>
                        </div>
                        <div className="panel-body">
                            <div className="row">
                                <div className="col-md-offset-2 col-md-8">
                                    <form>
                                        <div className="form-group">
                                            <label htmlFor="selectSchoolYear" className="control-label">School Year</label>
                                            <select className="form-control" id="selectSchoolYear">
                                            <option value="0"></option>
                                            {
                                                this.props.schoolYears.map((item,k)=>{
                                                    return <option key={k} value={item.schoolYearValue}>{item.schoolYearLabel}</option>
                                                })
                                            }
                                            </select>
                                        </div>
                                    </form>
                                </div>
                                <div className=" col-md-12">
                                    <div className="col-md-12 createmenu-grade-group" style={{display:(this.props.schoolGrades.length>0?'block':'none') }}>
                                        <label className="custom-label col-md-12 text-center" style={{margin: '5px 0px'}}>Select Grades</label>
                                        <div className="col-md-offset-3 col-md-7 input-group">
                                            <div class="styled-input-container styled-input--square">
                                                <div class="styled-input-single col-sm-12">
                                                    <input type="checkbox" name="fieldset-6" id="select_all"                                                    
                                                    disabled={this.props.schoolGrades.every((grade)=>{
                                                        return grade.enabled===false
                                                    })}
                                                    onChange={this.allGrades}/>
                                                    <label htmlFor="select_all">All</label>
                                                </div>
                                                {
                                                    this.props.schoolGrades.map(grade => {
                                                        return (
                                                            <div className="styled-input-single col-md-2 pull-left"
                                                                 style={{margin: '-15px 0px'}}>
                                                                <input type="checkbox" name="grades"
                                                                    onChange={this.checkAllGrades}
                                                                    id={grade.name} value={grade.name} 
                                                                    checked={grade.checked?true:false}
                                                                    disabled={grade.enabled?false:true}
                                                                />
                                                                <label className={ !grade.enabled? 'disable-checkbox':''}  
                                                                htmlFor={grade.name}>{grade.name}</label>
                                                            </div>
                                                        );
                                                    }
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-offset-2 col-md-8">
                                    <div className="createmenu-link-group">
                                            <p className="input-group col-md-12 col-sm-12 col-xs-12 text-center">Upload Meal data to create the menu. Download&nbsp;<a
                                                href="https://s3.amazonaws.com/mealmanage-prod/SampleFiles/MealMenu.xlsx"
                                                download>Sample
                                                file</a>
                                            </p>
                                    </div>
                                    <div className="text-center">
                                        <label className="control-label"> Import Meal Data </label>
                                    </div>
                                    <div className="uploadFileInfo createmenu-file-group">                                        
                                            <div className="input-group" style={{marginLeft:'35px'}}>                                                 
                                                <input type="file" className="form-control"
                                                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                    style={{opacity: '1', zIndex: '0'}}
                                                    id="mealFile" aria-describedby="basic-addon21" 
                                                    onChange={(e)=>{
                                                        let validExts = new Array(".xlsx", ".xls");
                                                        let fileExt = e.target.files[0].name.split('.').pop();
                                                        const fileSize = e.target.files[0].size;
                                                        const fileMb = fileSize / 1024 ** 2;
                                                        if (validExts.indexOf('.'+fileExt) < 0) {
                                                           // _addNotificationError("Invalid file format. Please select valid file format (" +
                                                            //    validExts.toString() + ")",this);
                                                          //  e.target.value='';
                                                        return false;
                                                        }else if(fileMb >= 2){
                                                            _addNotificationError("Please select a file less than 2MB.",this);
                                                            e.target.value='';
                                                            return false;
                                                        }
                                                        else return true;
                                                   }}
                                                />
                                                <button id="OpenUpload"
                                                        className="input-group-addon" onClick={() => {
                                                    $('#mealFile').click()
                                                }}><i
                                                    className="fa fa-upload"
                                                    aria-hidden="true"/>
                                                </button>
                                            </div>
                                        
                                    </div>

                                    <div className="text-center">
                                        <button type="submit" id="submit" className="btn btn-sm btn-primary"><i
                                            className="fa fa-arrow-circle-right"></i><span>Proceed</span></button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>)
    }

}
export default YearMealForm;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Menu/yearMeal/yearMealForm.jsx